import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getShipping = async (details) => {
  	var response = await axios
    	.post(process.env.REACT_APP_API_URL + "/shipping", 
        { 
            "weight" : details.weight,
            "orderId" : details.orderId,
            "paymentType": details.paymentType, 
            "balance": details.balance
        }, 
    { headers: AuthHeader.authHeader()});
	return response.data;
};

const ShippingService = {
    getShipping,
    
};
export default ShippingService;